import stylingSetup from './styling-setup';
export default function () {
  stylingSetup();
}
